import styled from 'styled-components';

import { config } from '_config';
import { theme } from '_constants/theme';
import Text from '_components/atomic/layouts/Card/Text';

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large32X * 10}px;
  width: 100%;
  padding-top: ${theme.spaces.large6X}px;

  position: relative;

  @media ${theme.devices.tablet} {
    padding: ${theme.spaces.large}px;
  }
`;

const StyledInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spaces.large2X}px;
  min-height: 542px;
  padding: ${theme.spaces.large}px;
  border-radius: 32px;
  background: ${`url(${config.basePath}/images/v4-light-grungy-texture_x2.png)`};
  background-position: 50%;
  background-repeat: no-repeat;
  background-blend-mode: hard-light;

  position: relative;

  @media ${theme.devices.tablet} {
    min-height: unset;
    flex-direction: column;
  }
`;

const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: ${theme.spaces.large11X}px;
  max-width: 592px;
  padding-top: ${theme.spaces.large2X}px;
  padding-bottom: ${theme.spaces.large2X}px;
  padding-left: ${theme.spaces.large}px;
  padding-right: ${theme.spaces.large}px;
  border-radius: 24px;
  border: 1px solid ${theme.colors.gray[100]};
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  background-color: ${theme.colors.white};
  position: relative;

  &:last-child {
    margin-top: ${theme.spaces.large11X}px;
    margin-bottom: unset;
  }

  @media ${theme.devices.tablet} {
    margin-bottom: unset;

    &:last-child {
      margin-top: unset;
    }
  }
`;

const StyledCardImageContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 92%;
  opacity: 0.2;

  img {
    height: 100%;
  }

  @media ${theme.devices.tablet} {
    height: unset;
    width: 50%;
  }
`;

const StyledCurve = styled.div`
  height: ${theme.spaces.large28X}px;
  margin-top: ${theme.spaces.large16X}px;
  width: 50%;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 40%;
    top: -100%;
    height: 100%;
    width: 50%;
    border-bottom-left-radius: 32px;
    border-bottom: 1px solid ${theme.colors.gray[200]};
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 90%;
    top: -1px;
    height: 100%;
    width: 50%;
    border-top-right-radius: 32px;
    border-top: 1px solid ${theme.colors.gray[200]};
  }

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const StyledLine1 = styled.div`
  display: block;
  position: absolute;
  left: calc(18% - 3px);
  top: 70px;
  height: 32px;
  width: 100px;
  border-bottom-right-radius: 32px;
  border-bottom: 1px solid ${theme.colors.gray[200]};
  transform: rotate(90deg);

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const StyledLine2 = styled.div`
  display: block;
  position: absolute;
  left: calc(70% - 45px);
  top: 213px;
  height: 1px;
  width: 130px;
  background-color: ${theme.colors.gray[200]};
  transform: rotate(69deg);

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const QuoteSection = () => {
  return (
    <StyledOuterContainer>
      <StyledCurve />
      <StyledLine1 />
      <StyledLine2 />
      <StyledInnerContainer>
        <StyledCardContainer>
          <Text size={theme.fontSizes.medium}>
            I am very satisfied with the services I received from Incorpified.
            My business has been using this service for 3 years, keeping me
            updated on all facets pertaining to business.
          </Text>
          <Text
            size={theme.fontSizes.small}
            weight={700}
            color={theme.colors.orange[600]}
          >
            - LINDA
          </Text>
          <StyledCardImageContainer>
            <picture>
              <source
                srcSet={`${config.basePath}/images/v4-headline2.svg`}
                type="image/svg"
              />
              <img
                src={`${config.basePath}/images/v4-headline2.svg`}
                alt="Bg Image"
              />
            </picture>
          </StyledCardImageContainer>
        </StyledCardContainer>
        <StyledCardContainer>
          <Text size={theme.fontSizes.medium}>
            Everyone at Incorpified has been first class and quick to respond to
            my service needs. I appreciate you going above and beyond and taking
            the time to educate me.
          </Text>
          <Text
            size={theme.fontSizes.small}
            weight={700}
            color={theme.colors.orange[600]}
          >
            - TIM A.
          </Text>
          <StyledCardImageContainer>
            <picture>
              <source
                srcSet={`${config.basePath}/images/v4-headline2.svg`}
                type="image/svg"
              />
              <img
                src={`${config.basePath}/images/v4-headline2.svg`}
                alt="Bg Image"
              />
            </picture>
          </StyledCardImageContainer>
        </StyledCardContainer>
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default QuoteSection;
